module.exports = __webpack_public_path__ + "assets/img/free_32.1cb31185.png";